import jquery from 'jquery';
import wwdev from '@wwdev/functions';
import * as bootstrap from 'bootstrap';

window.$ = window.jQuery = window.jquery = jquery;
window.wwdev = wwdev;
window.bootstrap = bootstrap;

$(document).on('click', '.collapse .hamburger', (event) => {
	event.preventDefault();
	$('.navbar-toggler').trigger('click');
});

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	}
});
